import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import Modal from "../../../../components/Common/Modal/Modal";
import {
  distributionHistory,
  distributionHistoryMode,
} from "../../../../utils/mainTabs/distribute/distributionHistory";
import classes from "./DistributionHistoryInfo.module.scss";
import { FormattedMessage } from "react-intl";

const DistributionHistoryInfo = ({ info, isViewModal, setisViewModal }) => {
  const tabs = useMemo(() => [<FormattedMessage id="DIST_HIST_COURSES" />, <FormattedMessage id="DIST_HIST_DISTRIBUTED_TO" />], []);
  const distributionMode = useMemo(
    () => [
      "UserGroups",
      "Tags",
      "SelectedUsers",
      "NextPush",
      "SpreadProgram",
      "NewJoinee",
      "Mandate Learning",
      "Refresher",
      "SelfAssignment",
      "DistributeCSV",
    ],
    []
  );
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const {
    distributionHistoryCoursesInfocolumns,
    distributionHistoryDistributedInfocolumns,
    distributionHistoryDistributedInfoForSelfAssignmentcolumns,
    distributionHistoryDistributedInfoForDistributionListcolumns,
  } = distributionHistory;
  const [tableColumns, setTableColumns] = useState([]);

  useEffect(() => {
    let newTableColumns;
    if (selectedTab === tabs[0])
      newTableColumns = distributionHistoryCoursesInfocolumns();
    else if (selectedTab === tabs[1]) {
      if (
        info?.DistributionMethod === distributionMode[0] ||
        info?.DistributionMethod === distributionMode[5]
      )
        newTableColumns = distributionHistoryDistributedInfocolumns();
      else if (
        info?.DistributionMethod === distributionMode[8] ||
        info?.DistributionMethod === distributionMode[2] ||
        info?.DistributionMethod === distributionMode[3] ||
        info?.DistributionMethod === distributionMode[4]
      )
        newTableColumns =
          distributionHistoryDistributedInfoForSelfAssignmentcolumns();
      else if (info?.DistributionMethod === distributionMode[1])
        newTableColumns =
          distributionHistoryDistributedInfoForDistributionListcolumns();
    }
    setTableColumns(newTableColumns);
  }, [
    distributionHistoryCoursesInfocolumns,
    distributionHistoryDistributedInfocolumns,
    tabs,
    selectedTab,
    distributionMode,
    distributionHistoryDistributedInfoForSelfAssignmentcolumns,
    distributionHistoryDistributedInfoForDistributionListcolumns,
    info,
  ]);

  return (
    <Modal
      isOpen={isViewModal}
      heading={<FormattedMessage id="DETAILS_TEXT" />}
      toggle={() => setisViewModal(false)}
      width={"60"}
    >
      <div className={classes.distributeHistoryInfo}>
        <div className={classes.heading}>
          <span className={classes.text}><FormattedMessage id="DIST_HIST_DISTRIBUTION_MODE" />:</span>{" "}
          {distributionHistoryMode(info?.DistributionMethod)}
        </div>
        <div className={classes.tabs}>
          {tabs?.map((val) => (
            <span
              key={val}
              className={
                val === selectedTab ? classes.activeTab : classes.notActiveTab
              }
              onClick={() => setSelectedTab(val)}
            >
              {val}
            </span>
          ))}
        </div>
        {selectedTab === tabs[0] && (
          <DataTable
            columns={tableColumns}
            defaultData={info?.RequestModel?.ClassGroups}
            data={info?.RequestModel?.ClassGroups}
            totalRows={info?.RequestModel?.ClassGroups?.length}
            uniqueFieldName={"ID"}
          />
        )}
        {selectedTab === tabs[1] &&
          (info?.DistributionMethod === distributionMode[8] ||
            info?.DistributionMethod === distributionMode[2] ||
            info?.DistributionMethod === distributionMode[3] ||
            info?.DistributionMethod === distributionMode[4]) && (
            <DataTable
              columns={tableColumns}
              defaultData={info?.RequestModel?.SelectedUsers}
              data={info?.RequestModel?.SelectedUsers}
              totalRows={info?.RequestModel?.SelectedUsers?.length}
              uniqueFieldName={"Id"}
            />
          )}
        {selectedTab === tabs[1] &&
          (info?.DistributionMethod === distributionMode[0] ||
            info?.DistributionMethod === distributionMode[5]) && (
            <DataTable
              columns={tableColumns}
              defaultData={info?.RequestModel?.UserGroups}
              data={info?.RequestModel?.UserGroups}
              totalRows={info?.RequestModel?.UserGroups?.length}
              uniqueFieldName={"UserGroupId"}
            />
          )}
        {selectedTab === tabs[1] &&
          info?.DistributionMethod === distributionMode[1] && (
            <DataTable
              columns={tableColumns}
              defaultData={[info?.RequestModel?.TagExpression]}
              data={[info?.RequestModel?.TagExpression]}
              totalRows={1}
              uniqueFieldName={"UserGroupId"}
            />
          )}
      </div>
    </Modal>
  );
};

export default DistributionHistoryInfo;
